import { Provider } from '@angular/core';
import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MsalBroadcastService,
	MsalGuard,
	MsalGuardConfiguration,
	MsalService,
} from '@azure/msal-angular';
import {
	BrowserCacheLocation,
	InteractionType,
	IPublicClientApplication,
	PublicClientApplication,
} from '@azure/msal-browser';

import { environment } from '~app-environment';

export function MSALInstanceFactory(version: string): IPublicClientApplication {
	const url = new URL(window.location.href);
	url.pathname = '/auth/sign-in';
	url.search = '';
	url.hash = '';

	return new PublicClientApplication({
		auth: {
			clientId: environment.socialSignIn.microsoftClientId,
			redirectUri: url.href,
			authority: `https://login.microsoftonline.com/${environment.socialSignIn.microsoftAuthority}`,
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
		},
		telemetry: {
			application: {
				appName: 'myReach',
				appVersion: version,
			},
		},
	});
}

// MSAL Guard is required to protect routes and require authentication before accessing protected routes
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Popup,
		authRequest: {
			scopes: ['Profile', 'User.Read', 'ProfilePhoto.Read.All'],
		},
	};
}

export const provideMicrosoftAuthentication = (version: string): Provider[] => {
	const url = new URL(window.location.href);
	const canUseMicrosoftLogin = url.protocol === 'https:' || url.hostname === 'localhost';

	if (!canUseMicrosoftLogin) {
		return [];
	}

	return [
		{
			provide: MSAL_INSTANCE,
			useFactory: () => MSALInstanceFactory(version),
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
	];
};
